import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance as axios } from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  data: null,
};

const slice = createSlice({
  name: 'portalDashboard',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET PORTAL DASHBOARD
    getPortalDashboardSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getPortalDashboard() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/hr/me/dashboard');
      dispatch(slice.actions.getPortalDashboardSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
